/**
 * Clean & Box PDP — force body/silk-matched copy size.
 * Injects a <style> tag (does not rely on CSS asset sync).
 * Target: same as silk note / theme body (1.5rem → 1.6rem).
 * sync-bust: 2026-08-03-silk-type-inject
 */
(function () {
  if (window.__mdbPdpSilkType) return;
  window.__mdbPdpSilkType = true;

  function inject() {
    if (document.getElementById('mdb-pdp-silk-type')) return;
    if (!document.querySelector('.mdb-pdp, [data-mdb-pdp-root]')) return;

    var style = document.createElement('style');
    style.id = 'mdb-pdp-silk-type';
    style.textContent =
      '.mdb-pdp{--mdb-pdp-copy-size:1.5rem;--mdb-pdp-copy-leading:calc(1 + 0.8 / var(--font-body-scale, 1));}' +
      '.mdb-pdp-fit__item,.mdb-pdp-fit__silk p,.mdb-pdp-social__quote p,.mdb-pdp-value__list li,' +
      '.mdb-pdp-stats__label,.mdb-pdp-faq .mdb-pdp-faq__body{' +
      'font-size:var(--mdb-pdp-copy-size)!important;' +
      'line-height:var(--mdb-pdp-copy-leading)!important;}' +
      '.mdb-pdp-faq .h2,.mdb-pdp-faq h2,.mdb-pdp-faq summary{' +
      'font-family:var(--font-body-family)!important;' +
      'font-style:var(--font-body-style)!important;' +
      'font-weight:600!important;letter-spacing:normal!important;}' +
      '.mdb-pdp-faq summary{font-size:var(--mdb-pdp-copy-size)!important;' +
      'line-height:var(--mdb-pdp-copy-leading)!important;}' +
      '@media screen and (min-width:750px){.mdb-pdp{--mdb-pdp-copy-size:1.6rem;}}';
    (document.head || document.documentElement).appendChild(style);
  }

  function boot() {
    inject();
    if (typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(function () {
        inject();
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () {
        try {
          obs.disconnect();
        } catch (e) {}
      }, 15000);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
